'use client';
import { usePathname } from 'next/navigation';
import * as Styled from './styled';

export type NavigationOptions = 'explore' | 'featured' | 'collections' | 'categories' | 'models';

const getSelection = (pathname: string, selected: NavigationOptions): NavigationOptions => {
  if (pathname === '/categories' || selected === 'categories') return 'categories';
  if (pathname === '/collections' || selected === 'collections') return 'collections';
  if (pathname === '/featured' || selected === 'featured') return 'featured';
  return 'explore';
};

const Navigation = ({ selected = 'explore' }: { selected: NavigationOptions }) => {
  const pathname = usePathname();
  const selection = getSelection(pathname, selected);
  return (
    <Styled.Navigation>
      <Styled.NavigationLink href={'/explore'} $selected={selection === 'explore'}>
        Explore
      </Styled.NavigationLink>
      {/* <Styled.NavigationLink href={'/featured'} $selected={selection === 'featured'}>
        Datasets
      </Styled.NavigationLink> */}
      <Styled.NavigationLink href={'/collections'} $selected={selection === 'collections'}>
        Collections
      </Styled.NavigationLink>
      <Styled.NavigationLink href={'/categories'} $selected={selection === 'categories'}>
        Categories
      </Styled.NavigationLink>
    </Styled.Navigation>
  );
};

export default Navigation;
